/* eslint-disable jsx-a11y/anchor-is-valid */


import React, { useEffect } from 'react'
import team_img from "../../assets/images/pictures/about-us-content-1.png"
import { motion } from 'framer-motion';
import routeVariants from '../../assets/animates/routeVariants';
import AboutUsTabs from './AboutUsTabs';
import { useTranslation } from 'react-i18next';
import gopaperless_team from "../../assets/images/pictures/about-us-content-2.jpg"
import NavbarBottom from './../global/NavbarBottom';
import Footer from './../global/Footer';
import ic_gopaperless from "../../assets/images/pictures/icon/ic_gopaperless.svg"
import { useState } from 'react';
import fa_thin_arrow_down from "../../assets/images/pictures/icon/fa-thin-arrow-down.svg"
import fa_thin_arrow_up from "../../assets/images/pictures/icon/fa-thin-arrow-up.svg"

const AboutUsContent = () => {
    const { t } = useTranslation()

    const [isExpanded, setIsExpanded] = useState(false);

    // const toggleText = () => {
        
    //     setIsExpanded(!isExpanded);  
    //   };

    
    //   useEffect(() => {
    //     if(isExpanded){
    //         document.getElementById('text-more-less').classList.add("active")
    //         document.getElementById('text-more-less').style.height = document.getElementById('text-more-less').scrollHeight + "px"
            
            
    //     }else{
    //         document.getElementById('text-more-less').classList.remove("active")
    //         document.getElementById('text-more-less').style.height = "492px"
    //     }
    //   },[isExpanded])
    
    

    return (
        <motion.div
            variants={routeVariants}
            initial="initial"
            animate="final"
            id="content" className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform overflow-hidden"
        >

            <div className="about-us">
                <div className="container pt-40 pb-40">
                    <div className="row text-center">
                        <div className="col-sm-12">
                            <h2 className='font-weight-bold font-60'>{t('about-us-page.about-us-page-content.content-1.heading')}</h2>
                        </div>
                        <div className="col-sm-12">
                            <p className='mb-50'>
                                {t('about-us-page.about-us-page-content.content-1.description')}</p>
                        </div>
                        <div className="col-sm-12 text-center">
                            <img width="500" src={team_img} className="img-responsive" alt="" decoding="async" loading="lazy" />
                        </div>
                    </div>

                </div>




                {/* <div className='container-fuild bg-primary'>
                    <div className="container p-md-0 mt-100  bor-rad-15">
                        <div className="row">
                            <div className='col-lg-5 px-md-0' id="left-column">

                                <img src={gopaperless_team} alt="" className='img-about-us-cover bor-rad-25-half mt-100 mb-100' />

                            </div>
                            <div className="col-lg-7 mb-100 bg-primary mt-100 pl-45 see-more-less-container" id="right-column">
                                <h2 className='font-weight-bold text-white m-0'>{t('about-us-page.about-us-page-content.content-2.heading')}</h2>
                                <br />
                                <p className='text-more-less' id="text-more-less">
                                <p className='text-white'>{t('about-us-page.about-us-page-content.content-2.description-1')}</p>
                                <br/>
                                <p className='text-white'>{t('about-us-page.about-us-page-content.content-2.description-2')}{t('about-us-page.about-us-page-content.content-2.description-3')}</p>
                                <br/>
                                <p className='text-white mb-10'>{t('about-us-page.about-us-page-content.content-2.description-4')}</p>
                                <br/>
                                <p className='text-white'>{t('about-us-page.about-us-page-content.content-2.description-5')}</p>
                                <br/>
                                <p className='text-white'>{t('about-us-page.about-us-page-content.content-2.description-6')}</p>
                                </p>
                                <p className='text-white read-less-more-button text-center pt-10' onClick={toggleText}>{isExpanded ? t('about-us-page.about-us-page-content.read-less') : t('about-us-page.about-us-page-content.read-more')}{isExpanded ? <img src={fa_thin_arrow_up} alt="" className='ml-5'/> : <img src={fa_thin_arrow_down} alt="" className='ml-5'/>}</p>
                            </div>
                        </div>

                    </div>
                </div> */}

                {/* <div className='container'>
                    <AboutUsTabs />
                </div> */}

                {/* <div className='container px-md-0 pb-100'>
                    <div className='row'>
                        <h2 className='font-weight-bold text-center'>History</h2>

                    </div>
                    <div className='row'>
                        <div className='col-md-6 col-sm-6 col-lg-3'>
                            <div className='about-us-panel-box'>
                                <img src={ic_stonk} alt=""/>
                                <h2 className='font-24 font-weight-bold m-0'>2016</h2>
                                <p>Mobile-ID became an associate member of FIDO Alliance.</p>
                            </div>
                            <p className='font-14 pt-5'>Sept 2016</p>
                            <div className='flex center--perfect center pt-5'>
                                <img src={ic_dot_yellow_circle} alt="" />
                                <div className='mini-crossbar center justity-center'></div>
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-lg-3'>
                            <div className='about-us-panel-box'>
                                <img src={ic_stonk} alt=""/>
                                <h2 className='font-24 font-weight-bold m-0'>2017 - 2018</h2>
                                <p>Trusted Hub Appliance is certified by FIDO UAF Server.
                                    Trusted Hub software is licensed by Mobile-ID which is verified by Copyright Office.</p>

                            </div>
                            <p className='font-14 pt-5'>Apr 2017 - Dec 2018</p>
                            <div className='flex center--perfect center pt-5'>
                                <img src={ic_dot_yellow_circle} alt="" />
                                <div className='mini-crossbar center justity-center'></div>
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-lg-3'>
                            <div className='about-us-panel-box'>
                                <img src={ic_stonk} alt=""/>
                                <h2 className='font-24 font-weight-bold m-0'>2019 - 2020</h2>
                                <p>Mobile-ID in collaboration with the Vietnamese Government Information Security Commission launch the MSSP service that provides digital signing on mobile SIM for e-government application.</p>
                            </div>
                            <p className='font-14 pt-5'>May 2019 - Dec 2020</p>
                            <div className='flex center--perfect center pt-5'>
                                <img src={ic_dot_yellow_circle} alt="" />
                                <div className='mini-crossbar center justity-center'></div>
                            </div>
                        </div>
                        <div className='col-md-6 col-sm-6 col-lg-3'>
                            <div className='about-us-panel-box'>
                                <img src={ic_stonk} alt=""/>
                                <h2 className='font-24 font-weight-bold m-0'>2021-Now</h2>
                                <p>Mobile-ID received ISO/IEC 27001:2013 certificate from IAF organization.</p>
                            </div>
                            <p className='font-14 pt-5'>Mar 2021 - Dec 2022</p>
                            <div className='flex center--perfect center pt-5'>
                                <img src={ic_dot_yellow_circle} alt="" />
                                <div className='mini-crossbar center justity-center'></div>
                            </div>
                        </div>
                    </div>

                </div> */}

                {/* <div className="security-footer container-fuild">
                
                    <div className="security-footer bg-color-E6F0FC">
                        <div className="row">

                            <div className="col-sm-12 text-center mbt-40">
                                <img src={ic_gopaperless} alt="" className='img-responsive' width="64" height="64" />
                                <h2 className="font-weight-bold pb-24">{t('about-us-page.about-us-page-content.content-4.heading')}</h2>
                                <a href="javascript:;" className="btn-primary">{t('about-us-page.about-us-page-content.content-4.button-see-open-positions')}</a>
                            </div>

                        </div>
                    </div>
                </div> */}
            </div>
            <Footer />
            <NavbarBottom />
        </motion.div>
    )
}

export default AboutUsContent